import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api.js";
import { logError } from "../lib/logger.js";

export interface LeaveTypeConfig {
  id:                   string;
  code:                 string;
  trackBalance:         boolean;
  genderRestriction:    string | null;
  maritalStatusRestriction: string | null;
  attachmentRequiredAboveDays: number | null;
  isProbationBlocked:   boolean;
  isNoticeBlocked:      boolean;
  isPipBlocked:         boolean;
  forceWfh:             boolean;
  maxDaysPerRequest:    number | null;
  requiresApproverRole: string;
  minNoticeDays:        number | null;
  retroactiveWindowDays: number;
  isEnabled:            boolean;
  accrualMode:          boolean;
}

type ConfigMap = Record<string, LeaveTypeConfig>;

const LeaveTypeConfigContext = createContext<ConfigMap>({});

export function LeaveTypeConfigProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<ConfigMap>({});

  useEffect(() => {
    api.get<LeaveTypeConfig[]>("/leave/type-config")
      .then(r => {
        const map: ConfigMap = {};
        for (const c of r.data) map[c.code] = c;
        setConfig(map);
      })
      .catch((err) => logError("LeaveTypeConfigContext.load", err));
  }, []);

  return <LeaveTypeConfigContext.Provider value={config}>{children}</LeaveTypeConfigContext.Provider>;
}

export function useLeaveTypeConfig(): ConfigMap {
  return useContext(LeaveTypeConfigContext);
}
